// import React, { useEffect, useState } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import Swal from 'sweetalert2';
// import axios from 'axios';
// import { Col, Row, Table, Badge, Button, Card } from 'react-bootstrap';
// import { BASE_URL } from '../../../services/Api';
// import { authHeader } from '../../../services/auth-header';

// function MDCView() {
//   const navigate = useNavigate();
//   const { id } = useParams();
//   const [isLoading, setIsLoading] = useState(true);
//   const [deliveryChallan, setDeliveryChallan] = useState(null);

//   const formatDate = (dateString) => {
//     if (!dateString) return '-';
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-IN');
//   };

//   const formatCurrency = (amount) => {
//     if (amount === null || amount === undefined) return '-';
//     return new Intl.NumberFormat('en-IN', {
//       style: 'currency',
//       currency: 'INR',
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(amount);
//   };

//   const getStatusBadge = (status) => {
//     switch (status) {
//       case 'Draft': return <Badge bg="secondary">Draft</Badge>;
//       case 'Open': return <Badge bg="primary">Open</Badge>;
//       case 'Completed': return <Badge bg="success">Completed</Badge>;
//       case 'Cancelled': return <Badge bg="danger">Cancelled</Badge>;
//       default: return <Badge bg="warning">Unknown</Badge>;
//     }
//   };

//   const getAddressString = (address) => {
//     if (!address) return '-';
//     return [
//       address.customeraddress,
//       address.city?.cityname,
//       address.state?.statename,
//       address.pincode,
//       address.country?.countryname
//     ].filter(Boolean).join(', ');
//   };

//   useEffect(() => {
//     const fetchDeliveryChallan = async () => {
//       try {
//         const response = await axios.get(`${BASE_URL}deliveryChallan/findById/${id}`, {
//           headers: authHeader(),
//         });
//         setDeliveryChallan(response.data);
//       } catch (error) {
//         console.error("Error fetching delivery challan:", error);
//         Swal.fire("Error", "Failed to load delivery challan data", "error");
//         navigate("/deliverychallanindex/1");
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchDeliveryChallan();
//   }, [id, navigate]);

//   if (isLoading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   if (!deliveryChallan) {
//     return (
//       <div className="container mt-4">
//         <div className="alert alert-danger">Delivery challan not found</div>
//       </div>
//     );
//   }

//   return (
//     <div className="container-fluid mt-3">

//       {/* Delivery Information Card */}
//       <Card className="mb-4">
//         <Card.Header>
//           <h5 className="mb-0">Delivery Information</h5>
//         </Card.Header>
//         <Card.Body>
//           <Row>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Delivery Note No.</label>
//                 <div>{deliveryChallan.deliverynoteno}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Delivery Note Date</label>
//                 <div>{formatDate(deliveryChallan.deliverynotedate)}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Status</label>
//                 <div className="border-bottom pb-1">{getStatusBadge(deliveryChallan.status)}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Sales Order No.</label>
//                 <div>{deliveryChallan.sono || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Dispatch Through</label>
//                 <div>{deliveryChallan.dispatchthrough || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Destination</label>
//                 <div>{deliveryChallan.destination || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Dispatch Doc No.</label>
//                 <div>{deliveryChallan.dispatchdocno || '-'}</div>
//               </div>
//             </Col>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Kind Attention</label>
//                 <div>{deliveryChallan.kindattn || '-'}</div>
//               </div>
//             </Col>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Terms of Delivery</label>
//                 <div>{deliveryChallan.termsofdelivery || '-'}</div>
//               </div>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>

//       {/* Customer Information with Bill To and Ship To */}
//       <Card className="mb-4">
//         <Card.Header>
//           <h5 className="mb-0">Customer Information</h5>
//         </Card.Header>
//         <Card.Body>
//           <Row>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Customer Name</label>
//                 <div>{deliveryChallan.customer?.companyname || '-'}</div>
//               </div>
//             </Col>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">GST No.</label>
//                 <div>{deliveryChallan.customer?.gstno || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Contact Person</label>
//                 <div>{deliveryChallan.contactperson || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Phone</label>
//                 <div>{deliveryChallan.contactno || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Email</label>
//                 <div>{deliveryChallan.email || '-'}</div>
//               </div>
//             </Col>
//           </Row>

//           {/* Bill To and Ship To in a side-by-side layout */}
//           <Row className="mt-3">
//             <Col md={6}>
//               <Card className="h-100">
//                 <Card.Header className="bg-light">
//                   <h6 className="mb-0">Bill To</h6>
//                 </Card.Header>
//                 <Card.Body>
//                   {deliveryChallan.billto ? (
//                     <>
//                       <div className="mb-2">
//                         <strong>Address:</strong>
//                         <div className="border p-2 rounded bg-light">
//                           {getAddressString(deliveryChallan.billto)}
//                         </div>
//                       </div>
//                       <div>
//                         <strong>GST:</strong> {deliveryChallan.billto.gstno || '-'}
//                       </div>
//                     </>
//                   ) : (
//                     <div className="text-muted">No billing address specified</div>
//                   )}
//                 </Card.Body>
//               </Card>
//             </Col>
//             <Col md={6}>
//               <Card className="h-100">
//                 <Card.Header className="bg-light">
//                   <h6 className="mb-0">Ship To</h6>
//                 </Card.Header>
//                 <Card.Body>
//                   {deliveryChallan.shipto ? (
//                     <>
//                       <div className="mb-2">
//                         <strong>Address:</strong>
//                         <div className="border p-2 rounded bg-light">
//                           {getAddressString(deliveryChallan.shipto)}
//                         </div>
//                       </div>
//                       <div>
//                         <strong>Contact:</strong> {deliveryChallan.shipto.contactperson || '-'}
//                       </div>
//                       <div>
//                         <strong>Phone:</strong> {deliveryChallan.shipto.contactno || '-'}
//                       </div>
//                     </>
//                   ) : (
//                     <div className="text-muted">No shipping address specified</div>
//                   )}
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>

//           <Row className="mt-3">
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Payment Term</label>
//                 <div>{deliveryChallan.customer?.paymentterm || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Freight</label>
//                 <div>{deliveryChallan.customer?.freight || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Packing & Forwarding</label>
//                 <div>{deliveryChallan.customer?.packingandforwarding || '-'}</div>
//               </div>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>

//       {/* Complete Branch Information */}
//       <Card className="mb-4">
//         <Card.Header>
//           <h5 className="mb-0">Branch Information</h5>
//         </Card.Header>
//         <Card.Body>
//           <Row>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Branch Name</label>
//                 <div>{deliveryChallan.branch?.branchname || '-'}</div>
//               </div>
//             </Col>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Branch GST</label>
//                 <div>{deliveryChallan.branch?.gstno || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Contact Person</label>
//                 <div>{deliveryChallan.branch?.contactperson || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Phone</label>
//                 <div>{deliveryChallan.branch?.phoneno || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Email</label>
//                 <div>{deliveryChallan.branch?.email || '-'}</div>
//               </div>
//             </Col>
//             <Col md={12}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Address</label>
//                 <div className="border p-2 rounded bg-light">
//                   {[
//                     deliveryChallan.branch?.address,
//                     deliveryChallan.branch?.city,
//                     deliveryChallan.branch?.state?.statename,
//                     deliveryChallan.branch?.zipcode,
//                     deliveryChallan.branch?.country?.countryname
//                   ].filter(Boolean).join(', ')}
//                 </div>
//               </div>
//             </Col>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Bank Name</label>
//                 <div>{deliveryChallan.branch?.bankname || '-'}</div>
//               </div>
//             </Col>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Account Number</label>
//                 <div>{deliveryChallan.branch?.accountno || '-'}</div>
//               </div>
//             </Col>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">IFSC Code</label>
//                 <div>{deliveryChallan.branch?.ifsccode || '-'}</div>
//               </div>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>

//       {/* Complete Warehouse Information */}
//       <Card className="mb-4">
//         <Card.Header>
//           <h5 className="mb-0">Warehouse Information</h5>
//         </Card.Header>
//         <Card.Body>
//           <Row>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Warehouse Name</label>
//                 <div>{deliveryChallan.warehouse?.warehousename || '-'}</div>
//               </div>
//             </Col>
//             <Col md={6}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Warehouse Type</label>
//                 <div>{deliveryChallan.warehouse?.warehousetype || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Contact Person</label>
//                 <div>{deliveryChallan.warehouse?.contactperson || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Phone</label>
//                 <div>{deliveryChallan.warehouse?.mobileno || '-'}</div>
//               </div>
//             </Col>
//             <Col md={4}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Email</label>
//                 <div>{deliveryChallan.warehouse?.email || '-'}</div>
//               </div>
//             </Col>
//             <Col md={12}>
//               <div className="mb-3">
//                 <label className="form-label fw-bold">Address</label>
//                 <div className="border p-2 rounded bg-light">
//                   {[
//                     deliveryChallan.warehouse?.address,
//                     deliveryChallan.warehouse?.city,
//                     deliveryChallan.warehouse?.state?.statename,
//                     deliveryChallan.warehouse?.zipcode,
//                     deliveryChallan.warehouse?.country?.countryname
//                   ].filter(Boolean).join(', ')}
//                 </div>
//               </div>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>

//       {/* Products Table */}
//       <Card className="mb-4">
//         <Card.Header>
//           <h5 className="mb-0">Products</h5>
//         </Card.Header>
//         <Card.Body>
//           <div className="table-responsive">
//             <Table striped bordered hover>
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>Description</th>
//                   <th>Part No.</th>
//                   <th>HSN</th>
//                   <th>Serial No.</th>
//                   <th>MOC</th>
//                   <th>Type</th>
//                   <th>Size</th>
//                   <th>Qty</th>
//                   <th>UOM</th>
//                   <th>Unit Price</th>
//                   <th>Amount</th>
//                   <th>GST %</th>
//                   <th>Total</th>
//                   <th>Remarks</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {deliveryChallan.deliveryChallanItems?.map((item, index) => (
//                   <tr key={index}>
//                     <td>{index + 1}</td>
//                     <td>{item.product?.description || '-'}</td>
//                     <td>{item.partno || '-'}</td>
//                     <td>{item.hsnsacno || '-'}</td>
//                     <td>{item.serialnumber || '-'}</td>
//                     <td>{item.product?.moc || '-'}</td>
//                     <td>{item.product?.type || '-'}</td>
//                     <td>{item.product?.size || '-'}</td>
//                     <td >{item.quantity}</td>
//                     <td>{item.uom || '-'}</td>
//                     <td >{formatCurrency(item.unitrateinr)}</td>
//                     <td >{formatCurrency(item.amount)}</td>
//                     <td >{item.gst}</td>
//                     <td >{formatCurrency(item.totalinr)}</td>
//                     <td>{item.productremarks || '-'}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           </div>
//         </Card.Body>
//       </Card>

//       {/* Additional Charges */}
//       {deliveryChallan.additionalCharges?.length > 0 && (
//         <Card className="mb-4">
//           <Card.Header>
//             <h5 className="mb-0">Additional Charges</h5>
//           </Card.Header>
//           <Card.Body>
//             <div className="table-responsive">
//               <Table striped bordered hover>
//                 <thead>
//                   <tr>
//                     <th>#</th>
//                     <th>Charge Type</th>
//                     <th>Amount</th>
//                     <th>GST %</th>
//                     <th>Total</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {deliveryChallan.additionalCharges.map((charge, index) => (
//                     <tr key={index}>
//                       <td>{index + 1}</td>
//                       <td>{charge.chargetype}</td>
//                       <td >{formatCurrency(charge.chargeamount)}</td>
//                       <td >{charge.chargegst}</td>
//                       <td >{formatCurrency(charge.chargetotal)}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </div>
//           </Card.Body>
//         </Card>
//       )}

//       {/* Summary Section */}
//       {/* Order Summary at Bottom */}
//       <Card className="mb-4">
//         <Card.Header>
//           <h5 className="mb-0">Delivery Challan Summary</h5>
//         </Card.Header>
//         <Card.Body>
//           <div className="border p-3 bg-light rounded">
//             <div className="d-flex justify-content-between mb-2">
//               <span className="fw-bold">Products Total:</span>
//               <span className="fw-bold">{formatCurrency(deliveryChallan.nettotalproduct)}</span>
//             </div>
//             {deliveryChallan.additionalCharges?.length > 0 && (
//               <div className="d-flex justify-content-between mb-2">
//                 <span className="fw-bold">Additional Charges:</span>
//                 <span className="fw-bold">{formatCurrency(deliveryChallan.additionalchargestotal)}</span>
//               </div>
//             )}
//             <div className="d-flex justify-content-between mb-2 border-top pt-2">
//               <span className="fw-bold">Gross Total:</span>
//               <span className="fw-bold">{formatCurrency(deliveryChallan.grosstotal)}</span>
//             </div>
//             <div className="d-flex justify-content-between border-top pt-2">
//               <span className="fw-bold fs-5">Grand Total:</span>
//               <span className="fw-bold fs-5">{formatCurrency(deliveryChallan.grandtotalproduct)}</span>
//             </div>
//           </div>
//         </Card.Body>
//       </Card>

//       {/* Action Buttons */}
//       <div className="d-flex justify-content-end gap-2 mb-4">
//         <Button variant="secondary" onClick={() => navigate(-1)}>
//           <i className="bi bi-arrow-left me-2"></i>Back to List
//         </Button>
//         <Button variant="primary" onClick={() => navigate(`/deliverychallan/edit/${id}`)}>
//           <i className="bi bi-pencil me-2"></i>Edit Delivery Challan
//         </Button>
//       </div>
//     </div>
//   );
// }

// export default MDCView;



import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import { Col, Row, Table, Badge, Card, Spinner, Container } from 'react-bootstrap';
import { BASE_URL } from '../../../services/Api';
import { authHeader } from '../../../services/auth-header';
import { FaArrowLeft } from 'react-icons/fa';

function MDCView() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [deliveryChallan, setDeliveryChallan] = useState(null);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN');
  };

  const formatCurrency = (value) =>
    new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
    }).format(value || 0);

  const getStatusBadge = (status) => {
    switch (status) {
      case 'Draft': return 'secondary';
      case 'Open': return 'primary';
      case 'Completed': return 'success';
      case 'Cancelled': return 'danger';
      default: return 'warning';
    }
  };

  const getAddressString = (address) => {
    if (!address) return '-';
    return [
      address.customeraddress,
      address.city?.cityname,
      address.state?.statename,
      address.pincode,
      address.country?.countryname
    ].filter(Boolean).join(', ');
  };

  useEffect(() => {
    const fetchDeliveryChallan = async () => {
      try {
        const response = await axios.get(`${BASE_URL}deliveryChallan/findById/${id}`, {
          headers: authHeader(),
        });
        setDeliveryChallan(response.data);
      } catch (error) {
        console.error("Error fetching delivery challan:", error);
        Swal.fire("Error", "Failed to load delivery challan data", "error");
        navigate("/deliverychallanindex/1");
      } finally {
        setIsLoading(false);
      }
    };

    fetchDeliveryChallan();
  }, [id, navigate]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (!deliveryChallan) {
    return <div className="alert alert-danger text-center mt-4">Delivery challan not found</div>;
  }

  return (
    <Container fluid className="p-3">
      {/* Header Section */}
      <Card className="shadow-sm border-0 rounded mb-3">
        <Card.Body className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="fw-bold text-primary mb-0">DELIVERY CHALLAN - VIEW</h5>
            <button className="btn btn-secondary btn-sm" onClick={() => navigate(-1)}>
              <FaArrowLeft className="me-1" />
              Back
            </button>
          </div>
          
          <Row className="g-2">
            <Col md={3}>
              <div className="border-start border-3 border-primary ps-2">
                <small className="text-muted">Delivery Note No</small>
                <div className="fw-bold">{deliveryChallan.deliverynoteno}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-success ps-2">
                <small className="text-muted">Delivery Note Date</small>
                <div className="fw-bold">{formatDate(deliveryChallan.deliverynotedate)}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-warning ps-2">
                <small className="text-muted">Sales Order No</small>
                <div className="fw-bold">{deliveryChallan.sono || '-'}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-info ps-2">
                <small className="text-muted">Status</small>
                <div>
                  <Badge 
                    bg={getStatusBadge(deliveryChallan.status)} 
                    className="px-2 py-1"
                  >
                    {deliveryChallan.status || '-'}
                  </Badge>
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Delivery Information */}
      <Card className="shadow-sm border-0 rounded mb-3">
        <Card.Header className="bg-light py-2">
          <h6 className="mb-0 fw-bold">Delivery Information</h6>
        </Card.Header>
        <Card.Body className="p-3">
          <Row className="g-3">
            <Col md={4}>
              <div className="mb-2">
                <small className="text-muted">SO Date</small>
                <div className="fw-bold">{formatDate(deliveryChallan.sodate)}</div>
              </div>
              <div>
                <small className="text-muted">Buyer Order Date</small>
                <div className="fw-bold">{formatDate(deliveryChallan.buyerorderdate)}</div>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-2">
                <small className="text-muted">Dispatch Through</small>
                <div className="fw-bold">{deliveryChallan.dispatchthrough || '-'}</div>
              </div>
              <div>
                <small className="text-muted">Destination</small>
                <div className="fw-bold">{deliveryChallan.destination || '-'}</div>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-2">
                <small className="text-muted">Dispatch Doc No</small>
                <div className="fw-bold">{deliveryChallan.dispatchdocno || '-'}</div>
              </div>
              <div>
                <small className="text-muted">Kind Attention</small>
                <div className="fw-bold">{deliveryChallan.kindattn || '-'}</div>
              </div>
            </Col>
            <Col md={12}>
              <div className="mt-2">
                <small className="text-muted">Terms of Delivery</small>
                <div className="fw-bold">{deliveryChallan.termsofdelivery || '-'}</div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Customer Information */}
      <Card className="shadow-sm border-0 rounded mb-3">
        <Card.Header className="bg-light py-2">
          <h6 className="mb-0 fw-bold">Customer Information</h6>
        </Card.Header>
        <Card.Body className="p-3">
          <Row className="g-3">
            <Col md={4}>
              <div className="mb-2">
                <small className="text-muted">Company Name</small>
                <div className="fw-bold">{deliveryChallan.customer?.companyname || '-'}</div>
              </div>
              <div>
                <small className="text-muted">GST No</small>
                <div className="fw-bold">{deliveryChallan.customer?.gstno || '-'}</div>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-2">
                <small className="text-muted">Contact Person</small>
                <div className="fw-bold">{deliveryChallan.contactperson || '-'}</div>
              </div>
              <div>
                <small className="text-muted">Phone</small>
                <div className="fw-bold">{deliveryChallan.contactno || '-'}</div>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-2">
                <small className="text-muted">Email</small>
                <div className="fw-bold">{deliveryChallan.email || '-'}</div>
              </div>
              <div>
                <small className="text-muted">Payment Term</small>
                <div className="fw-bold">{deliveryChallan.customer?.paymentterm || '-'}</div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Bill To and Ship To */}
      <Row className="mb-3">
        <Col md={6}>
          <Card className="shadow-sm border-0 rounded h-100">
            <Card.Header className="bg-light py-2">
              <h6 className="mb-0 fw-bold">Bill To</h6>
            </Card.Header>
            <Card.Body className="p-3">
              {deliveryChallan.billto ? (
                <>
                  <div className="mb-2">
                    <small className="text-muted">Address</small>
                    <div className="fw-bold">{getAddressString(deliveryChallan.billto)}</div>
                  </div>
                  <div>
                    <small className="text-muted">GST</small>
                    <div className="fw-bold">{deliveryChallan.billto.gstno || '-'}</div>
                  </div>
                </>
              ) : (
                <div className="text-muted">No billing address specified</div>
              )}
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="shadow-sm border-0 rounded h-100">
            <Card.Header className="bg-light py-2">
              <h6 className="mb-0 fw-bold">Ship To</h6>
            </Card.Header>
            <Card.Body className="p-3">
              {deliveryChallan.shipto ? (
                <>
                  <div className="mb-2">
                    <small className="text-muted">Address</small>
                    <div className="fw-bold">{getAddressString(deliveryChallan.shipto)}</div>
                  </div>
                  <div className="mb-2">
                    <small className="text-muted">Contact</small>
                    <div className="fw-bold">{deliveryChallan.shipto.contactperson || '-'}</div>
                  </div>
                  <div>
                    <small className="text-muted">Phone</small>
                    <div className="fw-bold">{deliveryChallan.shipto.contactno || '-'}</div>
                  </div>
                </>
              ) : (
                <div className="text-muted">No shipping address specified</div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Branch & Warehouse Information */}
      <Row className="mb-3">
        <Col md={6}>
          <Card className="shadow-sm border-0 rounded h-100">
            <Card.Header className="bg-light py-2">
              <h6 className="mb-0 fw-bold">Branch Information</h6>
            </Card.Header>
            <Card.Body className="p-3">
              <Row className="g-3">
                <Col md={6}>
                  <div className="mb-2">
                    <small className="text-muted">Branch Name</small>
                    <div className="fw-bold">{deliveryChallan.branch?.branchname || '-'}</div>
                  </div>
                  <div>
                    <small className="text-muted">Branch GST</small>
                    <div className="fw-bold">{deliveryChallan.branch?.gstno || '-'}</div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-2">
                    <small className="text-muted">Contact Person</small>
                    <div className="fw-bold">{deliveryChallan.branch?.contactperson || '-'}</div>
                  </div>
                  <div>
                    <small className="text-muted">Phone</small>
                    <div className="fw-bold">{deliveryChallan.branch?.phoneno || '-'}</div>
                  </div>
                </Col>
                <Col md={12}>
                  <div className="mt-2">
                    <small className="text-muted">Address</small>
                    <div className="fw-bold">
                      {[
                        deliveryChallan.branch?.address,
                        deliveryChallan.branch?.city,
                        deliveryChallan.branch?.state?.statename,
                        deliveryChallan.branch?.zipcode,
                        deliveryChallan.branch?.country?.countryname
                      ].filter(Boolean).join(', ')}
                    </div>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="shadow-sm border-0 rounded h-100">
            <Card.Header className="bg-light py-2">
              <h6 className="mb-0 fw-bold">Warehouse Information</h6>
            </Card.Header>
            <Card.Body className="p-3">
              <Row className="g-3">
                <Col md={6}>
                  <div className="mb-2">
                    <small className="text-muted">Warehouse Name</small>
                    <div className="fw-bold">{deliveryChallan.warehouse?.warehousename || '-'}</div>
                  </div>
                  <div>
                    <small className="text-muted">Warehouse Type</small>
                    <div className="fw-bold">{deliveryChallan.warehouse?.warehousetype || '-'}</div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-2">
                    <small className="text-muted">Contact Person</small>
                    <div className="fw-bold">{deliveryChallan.warehouse?.contactperson || '-'}</div>
                  </div>
                  <div>
                    <small className="text-muted">Phone</small>
                    <div className="fw-bold">{deliveryChallan.warehouse?.mobileno || '-'}</div>
                  </div>
                </Col>
                <Col md={12}>
                  <div className="mt-2">
                    <small className="text-muted">Address</small>
                    <div className="fw-bold">
                      {[
                        deliveryChallan.warehouse?.address,
                        deliveryChallan.warehouse?.city,
                        deliveryChallan.warehouse?.state?.statename,
                        deliveryChallan.warehouse?.zipcode,
                        deliveryChallan.warehouse?.country?.countryname
                      ].filter(Boolean).join(', ')}
                    </div>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Products Table */}
      <Card className="shadow-sm border-0 rounded mb-3">
        <Card.Header className="bg-light py-2">
          <h6 className="mb-0 fw-bold">Products</h6>
        </Card.Header>
        <Card.Body className="p-0">
          <div className="table-responsive">
            <Table bordered size="sm" className="mb-0">
              <thead className="table-light">
                <tr>
                  <th className="text-center fw-bold py-2">#</th>
                  <th className="fw-bold py-2">Description</th>
                  <th className="fw-bold py-2">Part No</th>
                  <th className="fw-bold py-2">HSN Code</th>
                  <th className="fw-bold py-2">Serial No</th>
                  <th className="fw-bold py-2">MOC</th>
                  <th className="fw-bold py-2">Type</th>
                  <th className="fw-bold py-2">Size</th>
                  <th className="fw-bold py-2 text-center">Qty</th>
                  <th className="fw-bold py-2 text-center">UOM</th>
                  <th className="fw-bold py-2 text-end">Unit Price</th>
                  <th className="fw-bold py-2 text-end">Amount</th>
                  <th className="fw-bold py-2 text-center">GST %</th>
                  <th className="fw-bold py-2 text-end">Total</th>
                </tr>
              </thead>
              <tbody>
                {deliveryChallan.deliveryChallanItems?.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td>
                    <td>
                      <div className="fw-semibold">{item.product?.description || '-'}</div>
                      {item.productremarks && (
                        <div className="text-muted small mt-1">
                          <small><strong>Remarks:</strong> {item.productremarks}</small>
                        </div>
                      )}
                    </td>
                    <td>{item.partno || '-'}</td>
                    <td>{item.hsnsacno || '-'}</td>
                    <td>{item.serialnumber || '-'}</td>
                    <td>{item.product?.moc || '-'}</td>
                    <td>{item.product?.type || '-'}</td>
                    <td>{item.product?.size || '-'}</td>
                    <td className="text-center">{item.quantity}</td>
                    <td className="text-center">{item.uom || '-'}</td>
                    <td className="text-end">{formatCurrency(item.unitrateinr)}</td>
                    <td className="text-end">{formatCurrency(item.amount)}</td>
                    <td className="text-center">{item.gst}%</td>
                    <td className="text-end fw-bold">{formatCurrency(item.totalinr)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="table-light">
                <tr>
                  <td colSpan="13" className="text-end fw-bold py-2">
                    Products Total:
                  </td>
                  <td className="text-end fw-bold py-2">
                    {formatCurrency(deliveryChallan.nettotalproduct)}
                  </td>
                </tr>
              </tfoot>
            </Table>
          </div>
        </Card.Body>
      </Card>

      {/* Additional Charges */}
      {deliveryChallan.additionalCharges?.length > 0 && (
        <Card className="shadow-sm border-0 rounded mb-3">
          <Card.Header className="bg-light py-2">
            <h6 className="mb-0 fw-bold">Additional Charges</h6>
          </Card.Header>
          <Card.Body className="p-0">
            <div className="table-responsive">
              <Table bordered size="sm" className="mb-0">
                <thead className="table-light">
                  <tr>
                    <th className="fw-bold py-2">#</th>
                    <th className="fw-bold py-2">Charge Type</th>
                    <th className="fw-bold py-2 text-end">Amount</th>
                    <th className="fw-bold py-2 text-center">GST %</th>
                    <th className="fw-bold py-2 text-end">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {deliveryChallan.additionalCharges.map((charge, index) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td>{charge.chargetype}</td>
                      <td className="text-end">{formatCurrency(charge.chargeamount)}</td>
                      <td className="text-center">{charge.chargegst}%</td>
                      <td className="text-end fw-bold">{formatCurrency(charge.chargetotal)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot className="table-light">
                  <tr>
                    <td colSpan="4" className="text-end fw-bold py-2">
                      Charges Total:
                    </td>
                    <td className="text-end fw-bold py-2">
                      {formatCurrency(deliveryChallan.additionalchargestotal)}
                    </td>
                  </tr>
                </tfoot>
              </Table>
            </div>
          </Card.Body>
        </Card>
      )}

      {/* Summary Section */}
      <Row>
        <Col lg={6} className="ms-auto">
          <Card className="shadow-sm border-0 rounded">
            <Card.Header className="bg-light py-2">
              <h6 className="mb-0 fw-bold text-center">Delivery Challan Summary</h6>
            </Card.Header>
            <Card.Body className="p-3">
              <div className="space-y-2">
                <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                  <span className="fw-semibold">Products Total:</span>
                  <span className="fw-bold">{formatCurrency(deliveryChallan.nettotalproduct)}</span>
                </div>
                
                {deliveryChallan.additionalCharges?.length > 0 && (
                  <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                    <span className="fw-semibold">Additional Charges:</span>
                    <span className="fw-bold">{formatCurrency(deliveryChallan.additionalchargestotal)}</span>
                  </div>
                )}

                <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                  <span className="fw-semibold">Gross Total:</span>
                  <span className="fw-bold">{formatCurrency(deliveryChallan.grosstotal)}</span>
                </div>

                <div className="d-flex justify-content-between align-items-center py-2 border-top">
                  <span className="fw-bold">Grand Total</span>
                  <span className="fw-bold text-primary">{formatCurrency(deliveryChallan.grandtotalproduct)}</span>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Footer Actions */}
      <div className="text-center mt-3 pt-2 border-top">
        <button 
          className="btn btn-secondary btn-sm me-2"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft className="me-1" />
          Back to List
        </button>
        {/* <button 
          className="btn btn-primary btn-sm"
          onClick={() => navigate(`/deliverychallan/edit/${id}`)}
        >
          Edit Delivery Challan
        </button> */}
      </div>
    </Container>
  );
}

export default MDCView;